import React, {FunctionComponent, useState, useRef, useEffect} from 'react';
import {Container, _ReactPixi} from '@inlet/react-pixi';
import {CoreSprite} from '@gongxigames/framework/core/fragments/react';
import {Graphics, Sprite} from 'pixi.js';

export type ProgressIndicatorProps = Omit<_ReactPixi.IContainer, 'position'> & {
    progress: number;
    position?: [x: number, y: number];
};

const MASK_OFFSET = 58;
const MASK_WIDTH = 896;
const MASK_HEIGHT = 128;
const MASK_MIN_WIDTH = 24;
const COVER_WIDTH = 46;
const COVER_TOP = 28;
const BAR_WIDTH = 1010;
const BAR_HEIGHT = 156;
const WIDTH_MULTIPLIER = 0.96;

export const ProgressIndicator: FunctionComponent<ProgressIndicatorProps> = (props) => {
    const [mask, setMask] = useState<Graphics>();
    const fill = useRef<Sprite>(null);
    const cover = useRef<Sprite>(null);

    useEffect(() => {
        const graphics = new Graphics()
            .beginFill(0xffffff)
            .drawRect(0, 0, MASK_WIDTH, MASK_HEIGHT)
            .endFill();

        fill.current!.addChild(graphics);
        setMask(graphics);
    }, []);

    if (fill.current) {
        const offset = Math.round((MASK_WIDTH - MASK_MIN_WIDTH) * props.progress) + MASK_MIN_WIDTH;

        mask!.x = MASK_OFFSET - MASK_WIDTH + offset;
        cover.current!.x = MASK_OFFSET + offset - COVER_WIDTH * WIDTH_MULTIPLIER + 1;
        cover.current!.y = COVER_TOP;
    }

    const x = (props.position?.[0] || 0) - BAR_WIDTH / 2;
    const y = (props.position?.[1] || 0) - BAR_HEIGHT / 2;

    return (
        <Container {...props} position={[x, y]} name='ProgressIndicator'>
            <CoreSprite src='loading_bar_empty'/>
            <CoreSprite src='loading_bar_full' mask={mask} ref={fill}/>
            <CoreSprite src='loading_bar_cover' ref={cover}/>
            <CoreSprite src='loading_bar_frame'/>
        </Container>
    );
};
